import { useEffect } from 'react';

export const disabledAutoComplete = {
  autoComplete: btoa(`utmost${Date.now()}`)
};

// used to workaround chrome auto-fill feature.
let dateStamp = Date.now();

export function getAnonymousName(name: string): string {
  return btoa(name) + dateStamp;
}

export function useAnonymousName(name: string): string {
  // biome-ignore lint/correctness/useExhaustiveDependencies: exception
  useEffect(
    () => () => {
      dateStamp = Date.now();
    },
    [name]
  );
  return getAnonymousName(name);
}
